// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".predmet-form .predmet-expand {\n  min-width: 38px !important;\n}\n.predmet-form .v-expansion-panel-content__wrap {\n  padding: 0;\n}\n.predmet-form .v-expansion-panel--active {\n  min-height: auto;\n}", ""]);
// Exports
module.exports = exports;
